import { ReactComponent as DeleteIcon } from 'assets/delete-red.svg';
import { ReactComponent as ViewIcon } from 'assets/view.svg';
import RoutePaths from 'routes/RoutePaths';
import { MenuOptionType, OptionComponentEnum } from './types';

export const MENU_OPTIONS: MenuOptionType[] = [
  {
    label: 'View Details',
    type: OptionComponentEnum.link,
    Icon: ViewIcon,
    routePath: (id) => `${RoutePaths.Businesses}/${id}`,
  },
  {
    label: 'Unfollow',
    type: OptionComponentEnum.button,
    Icon: DeleteIcon,
  },
  {
    label: 'Remove Account',
    type: OptionComponentEnum.button,
    Icon: DeleteIcon,
  },
];
